import React from 'react';
import PendingFees from './Pending_Fees';
import '../../../CommonCSS/SocietyCSS.css'

const PendingFeesApp = () => {
  return (

    <div className="app-wrapper">
      <div className="form-container">
        <div className='card' style={{borderRadius: '8px'}}>
          <div className="card-header-css" style={{borderRadius: '8px', textAlign: 'center' }} >
            <h5>Pending Fees</h5>
          </div>
        </div>
        <PendingFees />
      </div>
    </div >
  );
};

export default PendingFeesApp;
